import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toaster, TooltipProvider } from '@glucose-care/shared';

import { queryClient } from './lib/queryClient';
import { UserProvider } from './contexts/UserContext';
import { StaffProvider } from './contexts/StaffContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { TestResultsProvider } from './contexts/TestResultsContext';
import { LabProvider } from './contexts/LabContext';
import { InsuranceProvider } from './contexts/InsuranceContext';
import { AppContent } from './routes/AppContent';
import { CookieConsent } from './components/CookieConsent/CookieConsent';
import { GoogleAnalytics } from './components/Analytics/GoogleAnalytics';

// App only composes providers and mounts the app. Routing, guards, loaders,
// redirects, and route config live in ./routes and ./components/ui.
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Router>
          <UserProvider>
            <StaffProvider>
              <NotificationProvider>
                <TestResultsProvider>
                  <LabProvider>
                    <InsuranceProvider>
                      <AppContent />
                    </InsuranceProvider>
                  </LabProvider>
                </TestResultsProvider>
              </NotificationProvider>
            </StaffProvider>
          </UserProvider>
          <GoogleAnalytics />
          <CookieConsent />
          <Toaster />
        </Router>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;